<script setup>
import { Link } from '@inertiajs/inertia-vue3'

const props = defineProps({
  links: Array,
})

const formatLabel = (label) => {
  if (label === '&laquo; 前') return '<div class="arrow-left"></div>'
  if (label === '次 &raquo;') return '<div class="arrow-right"></div>'
  const r = label.length == 1 ? String('0') + String(label) : label
  return r
}
</script>
<template>
  <template v-if="props.links.length > 3">
    <div class="pagenation flex items-center justify-center font-rift font-bold tracking-wide text-[18px] px-[20px] mt-[30px] mb-[50px] sm:mt-[60px] sm:mb-[80px]">
      <template v-for="(link, key) in props.links">
        <div v-if="link.url === null" :key="key" class="!opacity-30 p-[4vw] xs:p-[15px]" v-html="formatLabel(link.label)" />
        <Link v-else :key="`link-${key}`" class="relative p-[4vw] xs:p-[15px] text-[#444]" :class="{ active: link.active }" :href="link.url" v-html="formatLabel(link.label)" />
      </template>
    </div>
  </template>
</template>
